import { createSlice } from '@reduxjs/toolkit';
import initialState from './App.state';
import reducers from './App.reducers';

export default createSlice({
	name: 'App',
	initialState,
	reducers,
});